import styled from 'styled-components';
export const ClearAllWrapper = styled.div `
  position: sticky;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.White};

  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 24px;
  top: 0;
`;
export const SelectAllClearAllButton = styled.button `
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  font-size: 14px;
  line-height: 24px;
  text-decoration-line: underline;
  background: none;
  outline: none;
  cursor: pointer;
  border: none;
  margin: 10px 0;
`;
export const NumSelected = styled.span `
  user-select: none;
  margin: 10px 0;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 24px;
`;
//# sourceMappingURL=BKJSelectSearchControls.styled.js.map